const form = {
  id: 'standards',
  title: 'Store Standards',
  description: 'Store standards report form.',
  questions: [
    {
      label: 'Intro',
      type: 'section',
      questions: [
        {
          label: 'Site',
          type: 'select',
          required: true,
          values: ['Brisbane, QLD, Australia', 'Sydney, NSW, Australia', 'Melbourne, VIC, Australia', 'Eden Prairie, MN, USA', 'Tulsa, OK, USA'],
        },
        {
          label: 'Inspection date/time',
          type: 'now',
        },
        {
          label: 'Weather',
          type: 'weather',
          lookup: 'Site',
        },
        {
          label: 'Type',
          type: 'select',
          values: ['Announced, Store Manager present', 'Announced, Store Manager not present'],
        },
      ],
    },
    {
      label: 'Store Information',
      type: 'section',
      questions: [
        {
          label: 'Franchise /  Store Manager Name',
          type: 'text',
          required: true,
        },
        {
          label: 'Employee on shift',
          type: 'text',
          required: true,
        },
        {
          label: 'Overview of Location (from entrance)',
          type: 'photos',
          required: true,
        },
      ],
    },
    {
      label: 'Front of House',
      type: 'section',
      scored: true,
      questions: [
        {
          label: 'Exterior of store is clean and free of debris. No visible rubbish and signage is clean.',
          score: 2,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'Seating area is clean. Tables are cleared during the visit.',
          score: 3,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'All interior and exterior windows are clean, free of fingerprints and dirt build up.',
          score: 3,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'Interior fixtures (e.g. lights, speakers, signage, murals, etc) are well-maintained, clean, free of dust build up and in working order.',
          score: 5,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'All surfaces (e.g. counters, etc) are clean.',
          score: 2,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
      ],
    },
    {
      label: 'Back of House',
      type: 'section',
      scored: true,
      questions: [
        {
          label: 'All surfaces are clean.',
          score: 5,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'All rubbish bins are clean and not overflowing.',
          score: 3,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'All freezers are clean and free of ice build up.',
          score: 3,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'Underneath all freezers, fridges, etc. are clean and free of food build up.',
          score: 5,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'It is evident drains have been cleaned recently and are free of odour.',
          score: 2,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
      ],
    },
    {
      label: 'Equipment Maintenance & Cleaning',
      type: 'section',
      scored: true,
      questions: [
        {
          label: 'Menu boards well lit and functioning properly.',
          score: 3,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'POS systems and display screens are functioning properly.',
          score: 3,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'All equipment and machines are on, in working order and well maintained.',
          score: 4,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'All fridges and freezers in good condition, working order and maintaining correct temperatures.',
          score: 4,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'There are no leaks or drips from equipment.',
          score: 2,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
        {
          label: 'Water temperature and pressure is adequate.',
          score: 2,
          type: 'yes-no',
          required: true,
          photo: 'optional',
          errorMessage: 'This is a required field.',
        },
      ],
    },
  ],
};

export default form;
